import React from "react";
import UserAvatar from "../../../../Chat/components/UserAvatar";
import { capitalizeString, customNames } from "src/utils/helpers";
import pluralize from "pluralize";
import { EnumUserGroup } from "src/scenes/Survey/components/Enums";
import BlueCheck from "src/img/survey/blue-check.svg";
import {
    StandardModalState,
    StandardModalTable,
    StandardModalTableScroll,
    StandardModalTableSection,
    UserSelectionCellText,
    UserSelectionCheckButton,
    UserSelectionNameCell,
    UserSelectionSelectButton,
    UserSelectionTable
} from "src/components";

const PollsUsersList = ({ usersToDisplay, handleSelectUser, selectedUserGroupType, selectedUsers }) => {

    const isSelected = (uuid) => selectedUsers.some((selectedItem) => selectedItem.uuid === uuid);

    const noUsersToDisplay = () => {
        return (
            <tr>
                <td colSpan="4">
                    <StandardModalState minHeight="6rem" border="0">No users to display</StandardModalState>
                </td>
            </tr>
        );
    };

    const renderClientsList = () => {
        if (!usersToDisplay || usersToDisplay.length === 0) {
            return noUsersToDisplay();
        }

        return usersToDisplay.map(user => {
            return (
                <tr key={user.uuid} className={isSelected(user.uuid) ? "is-selected" : ""}>
                    <td style={{ width: "50%" }}>
                        <UserSelectionNameCell>
                            <UserAvatar width="3.125rem" height="3.125rem" hideInfo={true}
                                photo={user.profilePictureUrl}
                                background="#D6D6D6"
                                firstName={user.firstName}
                                lastName={user.lastName}
                                statusBorder="1px solid #fff"
                                hideStatus={true}
                                withShadow={true}
                                borderPixel="1px"
                            />
                            <UserSelectionCellText>
                                {capitalizeString(user.firstName) + " " + capitalizeString(user.lastName)}
                            </UserSelectionCellText>
                        </UserSelectionNameCell>
                    </td>
                    <td style={{ width: "25%" }}>{user.employmentPosition || "-"}</td>
                    <td style={{ width: "25%" }}>
                        <div>
                            {isSelected(user.uuid) ?
                                <UserSelectionCheckButton type="button" onClick={() => handleSelectUser(user)} aria-label="Deselect user">
                                    <img src={BlueCheck} alt="" />
                                </UserSelectionCheckButton>
                                :
                                <UserSelectionSelectButton
                                    type="button"
                                    onClick={() => handleSelectUser(user)}
                                    aria-label="Select user"
                                />
                            }
                        </div>
                    </td>
                </tr>
            );
        });
    };

    const renderEmployeesList = () => {
        if (!usersToDisplay || usersToDisplay.length === 0) {
            return noUsersToDisplay();
        }

        return usersToDisplay.map(user => {
            return (
                <tr key={user.uuid} className={isSelected(user.uuid) ? "is-selected" : ""}>
                    <td style={{ width: "25%" }}>
                        <UserSelectionNameCell>
                            <UserAvatar width="3.125rem" height="3.125rem" hideInfo={true}
                                photo={user.profilePictureUrl}
                                background="#D6D6D6"
                                firstName={user.firstName}
                                lastName={user.lastName}
                                statusBorder="1px solid #fff"
                                hideStatus={true}
                                withShadow={true}
                                borderPixel="1px"
                            />
                            <UserSelectionCellText>
                                {capitalizeString(user.firstName) + " " + capitalizeString(user.lastName)}
                            </UserSelectionCellText>
                        </UserSelectionNameCell>
                    </td>
                    <td style={{ width: "25%" }}>{user.department || "-"}</td>
                    <td style={{ width: "25%" }}>{user.employmentPosition || "-"}</td>
                    <td style={{ width: "25%" }}>
                        <div>
                            {isSelected(user.uuid) ?
                                <UserSelectionCheckButton type="button" onClick={() => handleSelectUser(user)} aria-label="Deselect user">
                                    <img src={BlueCheck} alt="" />
                                </UserSelectionCheckButton>
                                :
                                <UserSelectionSelectButton
                                    type="button"
                                    onClick={() => handleSelectUser(user)}
                                    aria-label="Select user"
                                />
                            }
                        </div>
                    </td>
                </tr>
            );
        });
    };

    const renderClientsTableHeader = () => {
        return (
            <tr>
                <th style={{ width: "50%" }}>Name</th>
                <th style={{ width: "25%" }}> {capitalizeString(pluralize(customNames.clients.toLowerCase()))} Type</th>
                <th style={{ width: "25%" }}>Select User</th>
            </tr>
        );
    };

    const renderEmployeesTableHeader = () => {
        return (
            <tr>
                <th style={{ width: "25%" }}>Name</th>
                <th style={{ width: "25%" }}>Department / Group</th>
                <th style={{ width: "25%" }}>Job Title</th>
                <th style={{ width: "25%" }}>Select User</th>
            </tr>
        );
    };

    return (
        <StandardModalTableSection>
            <StandardModalTableScroll maxHeight="min(28rem, calc(100vh - 27rem))">
                <UserSelectionTable>
                    <StandardModalTable minWidth={selectedUserGroupType === EnumUserGroup.CLIENTS ? "640px" : "760px"}>
                        <thead>
                            {selectedUserGroupType === EnumUserGroup.CLIENTS ? renderClientsTableHeader() : renderEmployeesTableHeader()}
                        </thead>
                        <tbody>
                            {selectedUserGroupType === EnumUserGroup.CLIENTS ? renderClientsList() : renderEmployeesList()}
                        </tbody>
                    </StandardModalTable>
                </UserSelectionTable>
            </StandardModalTableScroll>
        </StandardModalTableSection>
    );
};

export default PollsUsersList;
